"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainConnectionSslValidationStatus = exports.DomainConnectionSslValidationErrors = exports.DomainConnectionDomainPointingStatus = exports.DomainConnectionDomainPointingErrors = exports.DomainConnectionStatus = void 0;
var DomainConnectionStatus;
(function (DomainConnectionStatus) {
    /**
     * The initial state, when the domain connection request is created but not yet processed.
     */
    DomainConnectionStatus["Requested"] = "REQUESTED";
    /**
     * The domain connection request is pending SSL certificate while waits for the user setup.
     */
    DomainConnectionStatus["PendingSslCert"] = "PENDING_SSL_CERT";
    /**
     * The domain connection request is pending DNS propagation after the SSL certificate has been generated.
     */
    DomainConnectionStatus["PendingDnsPropagation"] = "PENDING_DNS_PROPAGATION";
    /**
     * The domain connection request is pending connection CloudFront distribution after the DNS propagation.
     */
    DomainConnectionStatus["Pending"] = "PENDING_CONNECTION";
    /**
     * The domain connection request has been connected successfully.
     */
    DomainConnectionStatus["Connected"] = "CONNECTED";
    /**
     * The domain connection request has been disconnected.
     */
    DomainConnectionStatus["Disconnected"] = "DISCONNECTED";
    /**
     * The domain connection request is in the process of being disconnected.
     */
    DomainConnectionStatus["PendingDisconnection"] = "PENDING_DISCONNECTION";
})(DomainConnectionStatus || (exports.DomainConnectionStatus = DomainConnectionStatus = {}));
var DomainConnectionDomainPointingErrors;
(function (DomainConnectionDomainPointingErrors) {
    /**
     * Either the domain pointing record wasn't added or a wrong value was used, please check it out before trying again.
     */
    DomainConnectionDomainPointingErrors["Misconfiguration"] = "MISCONFIGURATION";
    /**
     * The domain pointing was properly added, but it won't work due to another A record conflicting with the CNAME one. The DNS resolution will prioritize the A over the CNAME, leading the client somewhere else.
     */
    DomainConnectionDomainPointingErrors["ARecordConflict"] = "A_RECORD_CONFLICT";
    /**
     * Unexpected cases.
     */
    DomainConnectionDomainPointingErrors["Other"] = "OTHER";
})(DomainConnectionDomainPointingErrors || (exports.DomainConnectionDomainPointingErrors = DomainConnectionDomainPointingErrors = {}));
var DomainConnectionDomainPointingStatus;
(function (DomainConnectionDomainPointingStatus) {
    DomainConnectionDomainPointingStatus["Pending"] = "PENDING";
    DomainConnectionDomainPointingStatus["Success"] = "SUCCESS";
    DomainConnectionDomainPointingStatus["Failed"] = "FAILED";
})(DomainConnectionDomainPointingStatus || (exports.DomainConnectionDomainPointingStatus = DomainConnectionDomainPointingStatus = {}));
var DomainConnectionSslValidationErrors;
(function (DomainConnectionSslValidationErrors) {
    /**
     * The certificate issuer has timed out, please ensure to properly add the required key before trying again.
     */
    DomainConnectionSslValidationErrors["Timeout"] = "TIMEOUT";
    /**
     * Either the certificate validation record wasn't added or a wrong value was used, please check it out before trying again.
     */
    DomainConnectionSslValidationErrors["Misconfiguration"] = "MISCONFIGURATION";
    /**
     * There is a CAA record on the provided domain, make sure to add one of the required certificate authority from AWS on the CAA list, see more at https://docs.aws.amazon.com/acm/latest/userguide/troubleshooting-caa.html.
     */
    DomainConnectionSslValidationErrors["InvalidCaaRecord"] = "INVALID_CAA_RECORD";
    /**
     * Unexpected cases.
     */
    DomainConnectionSslValidationErrors["Other"] = "OTHER";
})(DomainConnectionSslValidationErrors || (exports.DomainConnectionSslValidationErrors = DomainConnectionSslValidationErrors = {}));
var DomainConnectionSslValidationStatus;
(function (DomainConnectionSslValidationStatus) {
    DomainConnectionSslValidationStatus["Pending"] = "PENDING";
    DomainConnectionSslValidationStatus["Success"] = "SUCCESS";
    DomainConnectionSslValidationStatus["Failed"] = "FAILED";
})(DomainConnectionSslValidationStatus || (exports.DomainConnectionSslValidationStatus = DomainConnectionSslValidationStatus = {}));
//# sourceMappingURL=domain-connection.js.map